import React, { useState } from "react";
import { Field, FormikHelpers, ErrorMessage } from "formik";
import { email, required } from "../../utils/formValidations";
import { t } from "../../utils/i18n";

const StepTwo = ({
  errors,
  apiErrors,
  validateForm,
  handleChange,
  handleNextStepChange,
  handlePreviousStepChange
}) => (
  <>
    <div className="form-group row required">
      <label htmlFor="paymentEmail" className="form-label store-new-formlabel">
        {t("stores.form.payment_email")}
      </label>
      <small>
        {t("stores.form.payment_email_help")}
      </small>
      <Field
        id="paymentEmail"
        name="paymentEmail"
        className="form-control"
        validate={email}
        onChange={handleChange}
      />
      {errors.paymentEmail && (
        <div className="error">{errors.paymentEmail}</div>
      )}
      {apiErrors?.storePaymentEmailError && (
        <div className="error text-danger">
          {apiErrors.storePaymentEmailError}
        </div>
      )}
    </div>
    <div className="form-group row required">
      <label htmlFor="supportEmail" className="form-label store-new-formlabel">
        {t("stores.form.support_email")}
      </label>
      <small>
        {t("stores.form.support_email_help")}
      </small>
      <Field
        id="supportEmail"
        name="supportEmail"
        validate={email}
        className="form-control"
        onChange={handleChange}
      />
      {errors.supportEmail && (
        <div className="error">{errors.supportEmail}</div>
      )}
      {apiErrors?.storeSupportEmailError && (
        <div className="error text-danger">
          {apiErrors.storeSupportEmailError}
        </div>
      )}
    </div>
    <div className="form-group row required">
      <label htmlFor="address" className="form-label store-new-formlabel">
        {t("stores.form.address")}
      </label>
      <Field
        as="textarea"
        id="address"
        name="address"
        className="form-control"
        onChange={handleChange}
        validate={required}
      />
      {errors.address && <div className="error">{errors.address}</div>}
      {apiErrors?.storeAddressError && (
        <div className="error text-danger">{apiErrors.storeAddressError}</div>
      )}
    </div>
    <div className="form-group row">
      <label htmlFor="phone" className="form-label store-new-formlabel">
        {t("stores.form.telephone")}
      </label>
      <Field
        id="phone"
        name="phone"
        className="form-control"
        onChange={handleChange}
      />
      {errors.phone && <div className="error">{errors.phone}</div>}
      {apiErrors?.phoneError && (
        <div className="error text-danger">{apiErrors.phoneError}</div>
      )}
    </div>
    <div className="form-group row required">
      <label htmlFor="website" className="form-label store-new-formlabel">
        {t("stores.form.website")}
      </label>
      <small>
        {t("stores.form.website_help")}
      </small>
      <Field
        id="website"
        name="website"
        className="form-control"
        onChange={handleChange}
        validate={required}
      />
      {errors.website && <div className="error">{errors.website}</div>}
      {apiErrors?.storeUrlError && (
        <div className="error text-danger">{apiErrors.storeUrlError}</div>
      )}
    </div>

    <div className="action">
      <button
        type="button"
        className="btn store-paidbtn  left"
        onClick={() => handlePreviousStepChange("one")}
      >
        {t("stores.form.back")}
      </button>
      <button
        type="button"
        className="btn store-paidbtn right"
        onClick={e => handleNextStepChange(validateForm, "three")}
      >
        {t("stores.form.next")}
      </button>
    </div>
  </>
);

export default StepTwo;
